import React, { Component } from 'react';
import { compose, mapProps } from 'recompose';
import PropTypes from 'prop-types';
import { toFormattedLocalDate } from 'utils/dateTime/converter';
import { htmlToReact } from 'utils/functions';
import Answer from 'components/threepp/assessment/Answers/Answer';
import { isAssessmentReadOnly as isAssessmentReadOnlySelector } from 'selectors/assessment/selector';

import './Question.scss';
import { decodeHtml } from 'utils/htmlEncoderDecoder';
import { ActionsHOC } from '../Actions/ActionsHOC';

export class TemplateQuestion extends Component {
  static propTypes = {
    isAssessmentReadOnly: PropTypes.bool,
    // TODO: Fix this...
    /* eslint-disable react/forbid-prop-types */
    question: PropTypes.object.isRequired,
    template: PropTypes.object.isRequired,
    /* eslint-enable react/forbid-prop-types */
    incrementAttachmentUploadCount: PropTypes.func.isRequired,
    decrementAttachmentUploadCount: PropTypes.func.isRequired
  };

  static defaultProps = {
    isAssessmentReadOnly: false
  };

  getCalculatedValues = question => {
    const { textValue, numericValue } = question;
    let { listValue } = question;
    const localTimeValue = question.dateValue ? toFormattedLocalDate(question.dateValue, 'YYYY-MM-DD') : '';

    if (listValue && listValue.length > 1) {
      listValue = listValue.map(value => ` ${value} `);
    }
    return textValue || numericValue || listValue || localTimeValue;
  };

  isCalculated = (displayText, question) => (
    <table className="calculated-table">
      <tbody>
        <tr>
          <td className="calculated-label">{htmlToReact(displayText)}</td>
          <td className="calculated-text">{htmlToReact(this.getCalculatedValues(question))}</td>
        </tr>
      </tbody>
    </table>
  );

  render() {
    const {
      question,
      template,
      isAssessmentReadOnly,
      incrementAttachmentUploadCount,
      decrementAttachmentUploadCount,
      fieldAclAction,
      categoryAclAction,
      invokeActionsForFields,
      fieldFvlAction
    } = this.props;
    const { calculated, displayText, label } = question;

    return (
      fieldAclAction !== 'Hide' && (
        <div
          className={fieldAclAction === 'Hide' ? 'question-wrapper hide-question' : 'question-wrapper'}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          {calculated ? (
            this.isCalculated(displayText || label, question)
          ) : (
            <React.Fragment>
              <div className="question-title">
                <div className="prompt">
                  <div className="label">
                    {(question.required === true || fieldAclAction === 'Required') && <span className="required">* </span>}
                    {decodeHtml(question.label)}
                  </div>
                  <div className="display-text">{htmlToReact(displayText)}</div>
                </div>
              </div>
              <div className="container-fluid answer">
                <div className="row no-gutters">
                  <div className="col-md-12">
                    <Answer
                      calculated={calculated}
                      assessmentId={template.id}
                      recordId={template.recordId}
                      question={question}
                      filterValues={fieldFvlAction}
                      invokeActionsForFields={invokeActionsForFields}
                      disabled={isAssessmentReadOnly || fieldAclAction === 'ReadOnly' || categoryAclAction === 'ReadOnly'}
                      incrementAttachmentUploadCount={incrementAttachmentUploadCount}
                      decrementAttachmentUploadCount={decrementAttachmentUploadCount}
                      isNewRecord
                    />
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      )
    );
  }
}

export const TemplateQuestionHOC = compose(
  ActionsHOC,
  mapProps(props => ({
    question: props.question,
    template: props.template,
    actions: props.actions,
    invokeActionsForFields: props.invokeActionsForFields,
    categoryAclAction: props.categoryAclAction,
    fieldAclAction: props.aclAction,
    addAssignee: props.addAssignee,
    fieldFvlAction: props.fvlAction,
    isAssessmentReadOnly: isAssessmentReadOnlySelector(props),
    incrementAttachmentUploadCount: props.incrementAttachmentUploadCount,
    decrementAttachmentUploadCount: props.decrementAttachmentUploadCount,
    isNewRecord: props.isNewRecord
  }))
);

export default TemplateQuestionHOC(TemplateQuestion);
